import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UpgradeAccountPage } from './upgrade-account.page';

const routes: Routes = [
  {
    path: '',
    component: UpgradeAccountPage
  },
  {
    path: 'gold',
    loadChildren: () => import('./gold/gold.module').then( m => m.GoldPageModule)
  },
  {
    path: 'platinum',
    loadChildren: () => import('./platinum/platinum.module').then( m => m.PlatinumPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UpgradeAccountPageRoutingModule {}
